import { Gas, Electricity } from "./Icon";
export { Logo } from "./Logo";
var fontSizes = [
    "1.1rem",
    "1.4rem",
    "1.6rem",
    "2.0rem",
    "2.4rem",
    "2.8rem",
    "3.6rem",
    "4.8rem",
];
var brand = {
    midnight: "#00261C",
    forest: "#044D29",
    ovo: "#0A9828",
    leaf: "#16B639",
    energised: "#38E44C",
    sand: "#F9F6F3",
    white: "#FFFFFF",
    black: "#000000",
    focus: { base: "#385DE0" },
    primary: {
        muted: "#E7F3EA",
        lightest: "#FFFFFF",
        lighter: "#9DC431",
        light: "#6CBD27",
        base: "#0D8426",
        dark: "#0D8426",
        darker: "#006945",
    },
    grey: {
        lightest: "#FFFFFF",
        lighter: "#F9F9F9",
        light: "#F3F3F3",
        base: "#D1D6DE",
        dark: "#666D78",
        darker: "#2F3749",
        darkest: "#111111",
    },
    mission: {
        base: "#DE1D8D",
        dark: "#C6187D",
    },
    complementary: {
        base: "#197278",
    },
    electricity: {
        base: "#E7A234",
        dark: "#D1760A",
    },
    gas: {
        base: "#26ADE4",
        dark: "#3F64E6",
    },
    error: {
        lightest: "#FAE8EC",
        base: "#C7153E",
        dark: "#8C0A28",
    },
};
var colors = {
    primary: brand.primary.base,
    primaryAlt: brand.primary.darker,
    primaryContrast: "#FFFFFF",
    primaryMuted: brand.sand,
    error: "#9E0D2C",
    errorAlt: "#80001C",
    errorContrast: "#FFFFFF",
    errorMuted: "#FFEDF1",
    focus: "#3F64E6",
    focusMuted: "#C6D1F8",
    canvas: "#FFFFFF",
    body: brand.midnight,
    heading: brand.midnight,
    border: brand.midnight,
    canvasMuted: "#EBE7E3",
    borderMuted: "#EBE7E3",
    info: "#3F64E6",
    infoAlt: "#004CA0",
    infoContrast: "#FFFFFF",
    infoMuted: "#ECF0FD",
    warning: "#BE5409",
    warningAlt: "#8A3C05",
    warningContrast: "#FFFFFF",
    warningMuted: "#F7F0E7",
    success: brand.primary.base,
    successAlt: brand.primary.darker,
    successContrast: "#FFFFFF",
    successMuted: brand.primary.muted,
    mission: "#DE1D8D",
    missionMuted: "#FDF4F9",
    missionAlt: "#C6187D",
    missionContrast: "#FFFFFF",
    brand: brand,
};
export var themeConfig = {
    fonts: {
        body: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
        display: "'OVOCircular', Futura, 'Century Gothic', sans-serif",
    },
    fontSizes: fontSizes,
    heading: {
        fontWeight: 900,
        heading1: {
            marginBottom: ["1.2rem", "1.6rem"],
        },
        heading2: {
            marginBottom: ["1.2rem", "1.6rem"],
        },
        heading3: {
            marginBottom: ["1.2rem", "1.6rem"],
        },
        heading4: {
            marginBottom: ["1.2rem", "1.6rem"],
        },
    },
    shadows: {
        standard: "none;",
    },
    breakpoints: { small: "576px", medium: "768px", large: "1200px" },
    responsiveFontSizes: {
        display: ["1.8rem", "2.2rem"],
        small: ["1.4rem", "1.4rem"],
        body: ["1.6rem", "1.6rem"],
        level1: ["2.8rem", "4.8rem"],
        level2: ["2.4rem", "3.2rem"],
        level3: ["2.0rem", "2.8rem"],
        level4: ["1.6rem", "2.2rem"],
    },
    disclosure: {
        lineIndent: {
            width: "0",
        },
    },
    text: {
        p: {
            lineHeight: "2.4rem",
            marginTop: ["1.2rem", "1.2rem"],
            marginBottom: ["1.2rem", "1.2rem"],
        },
        small: {
            lineHeight: "2rem",
        },
    },
    card: {
        shadow: "none",
        borderRadius: "4px",
        borderWidth: "0",
    },
    colors: colors,
    input: {
        height: "4.4rem",
    },
    cta: {
        minHeight: "4.4rem",
        paddingHorizontal: "1.2rem",
        borderRadius: "24px",
        variants: {
            secondary: {
                background: colors.brand.midnight,
                foreground: colors.brand.white,
                backgroundHover: colors.brand.black,
                foregroundHover: colors.brand.white,
                border: colors.border,
                borderHover: colors.border,
            },
            missionPrimary: {
                background: brand.mission.base,
                foreground: brand.grey.lightest,
                backgroundHover: brand.mission.dark,
                foregroundHover: brand.grey.lightest,
                border: brand.mission.base,
                borderHover: brand.mission.dark,
            },
            // Deprecated. Removed from element.
            missionSecondary: {
                background: brand.grey.lightest,
                foreground: brand.mission.base,
                backgroundHover: "#FDF4F9",
                foregroundHover: brand.mission.dark,
                border: brand.mission.base,
                borderHover: brand.mission.dark,
            },
        },
    },
    radio: {
        touchSize: "4rem",
        dotColor: colors.info,
        borderWidth: "0.1rem",
    },
    checkbox: {
        touchSize: "4.4rem",
        size: "2.4rem",
        checkSize: "2rem",
        checkColor: colors.info,
        borderWidth: "0.1rem",
    },
    dataTable: {
        borderColor: colors.canvasMuted,
        tableCaption: {
            paddingVertical: "1.2rem",
            paddingHorizontal: "0.4rem",
        },
        tableCell: {
            paddingVertical: "1.2rem",
            paddingHorizontal: "0.4rem",
            borderColor: colors.canvasMuted,
        },
    },
    tabs: {
        tab: {
            borderTopWidth: "0.2rem",
            active: {
                foregroundColor: colors.primary,
            },
            inactive: {
                foregroundColor: colors.heading,
            },
        },
    },
    badge: {
        fontSize: ["1.6rem", "1.6rem"],
        variants: {
            default: {
                borderColor: colors.primaryMuted,
                background: colors.primaryMuted,
                foreground: colors.primaryAlt,
            },
            error: {
                borderColor: colors.errorMuted,
                background: colors.errorMuted,
                foreground: colors.errorAlt,
            },
            success: {
                borderColor: colors.successMuted,
                background: colors.successMuted,
                foreground: colors.successAlt,
            },
            info: {
                borderColor: colors.infoMuted,
                background: colors.infoMuted,
                foreground: colors.infoAlt,
            },
            warning: {
                borderColor: colors.warningMuted,
                background: colors.warningMuted,
                foreground: colors.warningAlt,
            },
        },
    },
    notification: {
        padding: ["1.2rem", "1.6rem"],
    },
};
export var icons = {
    gas: Gas,
    electricity: Electricity,
};
